export const BASE_URL = process.env.REACT_APP_GRAPHQL_URL || '';
export const GRAPHQL_URL = `${BASE_URL}/graphql/`;
